import React from 'react';

const LeadStatusPage = React.lazy(() => import('pages/LeadStatus/LeadStatusPage'));
const LeadStatusAddPage = React.lazy(() => import('pages/LeadStatus/LeadStatusAddPage'));

const LEAD_STATUS_PERMISSION = {
  VIEW: 'CRM_LEADSTATUS_VIEW',
  ADD: 'CRM_LEADSTATUS_ADD',
  EDIT: 'CRM_LEADSTATUS_EDIT',
};

const leadStatusRoute = [
  {
    path: '/lead-status',
    exact: true,
    name: 'Danh sách trạng thái lead',
    function: LEAD_STATUS_PERMISSION.VIEW,
    component: LeadStatusPage,
  },
  {
    path: '/lead-status/add',
    exact: true,
    name: 'Thêm mới trạng thái lead',
    function: LEAD_STATUS_PERMISSION.ADD,
    component: LeadStatusAddPage,
  },
  {
    path: '/lead-status/edit/:lead_status_id',
    exact: true,
    name: 'Chỉnh sửa trạng thái lead',
    function: LEAD_STATUS_PERMISSION.EDIT,
    component: LeadStatusAddPage,
  },
  {
    path: '/lead-status/detail/:lead_status_id',
    exact: true,
    name: 'Chi tiết trạng thái lead',
    function: LEAD_STATUS_PERMISSION.VIEW,
    component: LeadStatusAddPage,
  },
];

export default leadStatusRoute;
